import React, { useId } from "react";
import { offer } from "../data/offer";
type PurchaseButtonProps = {
  label: string;
  className?: string;
};

// Bouton d'achat : actif uniquement lorsque offer.checkoutUrl est renseigné.
export function PurchaseButton({
  label,
  className = ""
}: PurchaseButtonProps) {
  const noteId = useId();
  const isReady = offer.checkoutUrl.trim().length > 0;
  const content = <span className="flex flex-col items-center leading-tight sm:flex-row sm:gap-2" data-id="element-211" data-mp="qq8unszl1q10">
      <span data-id="element-212" data-mp="vp27rkayjf0n">{label}</span>
      <span className="hidden sm:inline" aria-hidden="true" data-id="element-213" data-mp="vplhweud8z44">
        —
      </span>
      <span data-id="element-214" data-mp="hxx2o2otluix">{offer.price}</span>
    </span>;
  const base = "flex w-full items-center justify-center whitespace-nowrap rounded-full px-6 pb-3.5 pt-4 font-display text-lg font-extrabold uppercase tracking-wide text-white md:text-xl";
  if (isReady) {
    return <a href={offer.checkoutUrl} className={`${base} bg-tangerine shadow-[0_5px_0_#C4560A] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-tangerine-dark active:translate-y-[3px] active:shadow-[0_2px_0_#C4560A] focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-royal ${className}`} data-id="element-215" data-mp="19mqkg4uvffum">
        {content}
      </a>;
  }
  return <div className={className} data-id="element-216" data-mp="wvz3kfxn56in">
      <button type="button" disabled aria-describedby={noteId} className={`${base} cursor-not-allowed bg-tangerine/60`} data-id="element-217" data-mp="wuo3aq3emgwa">
        {content}
      </button>
      <p id={noteId} className="mt-2.5 text-center text-xs font-semibold text-cocoa-soft" data-id="element-218" data-mp="16linzq1058fm">
        Les commandes ouvriront très prochainement.
      </p>
    </div>;
}